import ReactGA from 'react-ga4';

/**
 * Google Analytics初期化
 * @param {string} measurementId - Google AnalyticsのMeasurement ID (G-XXXXXXXX)
 */
export const initGA = (measurementId) => {
    // 本番環境の場合のみ初期化（開発環境ではスキップ）
    if (process.env.NODE_ENV === 'production') {
        ReactGA.initialize(measurementId);
        console.log('Google Analyticsが初期化されました');
    } else {
        console.log('開発環境: Google Analyticsは無効化されています');
    }
};

/**
 * ページビューイベントを送信
 * @param {string} page - ページのパス（例: /home）
 */
export const pageview = (page) => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.send({ hitType: "pageview", page });
    }
};

/**
 * イベントを送信
 * @param {Object} params - イベントパラメータ
 * @param {string} params.category - イベントカテゴリ
 * @param {string} params.action - イベントアクション
 * @param {string} [params.label] - イベントラベル（任意）
 * @param {number} [params.value] - イベント値（任意）
 */
export const event = ({ category, action, label, value }) => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.event({
            category,
            action,
            label,
            value
        });
    }
};

/**
 * エラーイベントを送信
 * @param {string} description - エラーの説明
 * @param {boolean} [fatal=false] - 致命的なエラーかどうか
 * @param {Object} [errorObj] - 追加のエラー情報
 */
export const exception = (description, fatal = false, errorObj = null) => {
    if (process.env.NODE_ENV === 'production') {
        // 基本的なエラー情報
        const exceptionData = {
            description,
            fatal
        };

        // 追加のエラー情報があれば、安全な形でマージ
        if (errorObj) {
            // スタックトレースなど機密性が高い可能性のある情報は除外
            // エラーコードやメッセージなど有用な情報のみ抽出
            const safeErrorInfo = {
                code: errorObj.code || 'unknown',
                status: errorObj.status || errorObj.statusCode,
                endpoint: errorObj.endpoint || errorObj.url,
                type: errorObj.type || errorObj.name
            };

            // 説明に簡潔な追加情報を付与
            exceptionData.description = `${description} (${safeErrorInfo.code || safeErrorInfo.type || 'unknown'})`;
        }

        ReactGA.exception(exceptionData);
    }
};

/**
 * ユーザーID設定（認証後に呼び出す）
 * 注意: 個人を特定できる情報は含めないこと
 * @param {string} userId - ハッシュ化されたユーザーID
 */
export const setUserId = (userId) => {
    if (process.env.NODE_ENV === 'production' && userId) {
        ReactGA.set({ userId });
    }
}; 